import { render, staticRenderFns } from "./ReturnedPackageInfo.vue?vue&type=template&id=f7e2b06e&"
import script from "./ReturnedPackageInfo.vue?vue&type=script&lang=js&"
export * from "./ReturnedPackageInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports